




















import { FormElementTag } from '@/models/FormElement';
import { BModal } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

function randomHex() {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
}

@Component({
    name: 'ModalTagConfig',
    components: {
        'b-modal': BModal,
    },
})
export default class BaseFilter extends Vue {
    input: FormElementTag = {
        id: null,
        uri: '',
        active: false,
        visible: true,
        form: null,
        title: 'Your tag title',
        hex: randomHex(),
    };

    @Prop() tag!: FormElementTag;
    @Prop() form!: string;

    reset() {
        if (!this.tag) {
            this.input.hex = randomHex();
        }
    }

    mounted() {
        if (this.tag) {
            this.input = this.tag;
        }
    }

    async submit() {
        await this.$store.dispatch(`formElementTags/${this.input.id ? 'update' : 'create'}`, {
            id: this.input.id || null,
            form: this.form,
            title: this.input.title,
            hex: this.input.hex,
        });
    }
}
